import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { CreateElement, Log } from "../.././MyHelpers";
import { IWinLine } from "../WinLine";
import { GenericWinLinesAnimation, WinLinesAnimationParams, WinLinesAnimationCompleteCallback, WinLinesAnimationNewLineCallback } from "./GenericWinLinesAnimation";
import { WinLines } from "./WinLines";
import { ISystemContext } from "../../Context/SystemContext";
import { IChangeableInterval, IInterval } from "../../Context/Interval";
import { WinLineMarkers } from "../WinLineMarkers";
import { ZIndex } from "../../ZIndex";
import { LineWin } from "../../api";
import { WinLineInfo1Marker } from "../WinLineInfo1Marker";
export class WinLinesAnimation extends GenericWinLinesAnimation
{

	private winLines: WinLines = null; 

	private lastResultLines: LineWin[] = [];
	private currentLineIndex: number = 0;
	private lineDuration: number;
	protected bars: WinLineInfo1Marker;
	protected barsLeftView: HTMLElement;
	protected barsRightView: HTMLElement;

	//private timer: number = 0;

	private systemContext: ISystemContext;
	private nextLineInterval: IChangeableInterval;

	private logGroup: string = "WinLinesAnimation";

	protected readonly animateOnlyWinningSymbols: boolean = false;
	protected winLineMarkers: WinLineMarkers = null;
	protected view: HTMLElement;
	protected params: WinLinesAnimationParams;

	constructor(params: WinLinesAnimationParams)
	{
		super();
		this.params = params;
		this.lineDuration = params.speedFactorAnimation;
		this.winLines = new WinLines(params.spinnableReels.GetWindowRect(), params.spinnableReels.GetWindowSymbolSize(), params.lines);

		this.systemContext = params.systemContext.CreateSubContext("WinLinesAnimation");

		this.nextLineInterval = this.systemContext.TimingContext().CreateChangeableInterval("nextLineInterval", 1000, () => {
			this.NextLine();
		});
		this.winLineMarkers = new WinLineMarkers(params.slotWindow, params.spinnableReels.GetWindowSymbolSize(), params.lines);
		this.bars = new WinLineInfo1Marker(params.slotWindow, params.spinnableReels.GetWindowSymbolSize(), params.lines);
		this.bars.CreateGroups(params.colorLineMarkers)
		this.barsLeftView = this.bars.LeftView();
		this.barsRightView = this.bars.RightView();
	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		// nothing to load here
	}

	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		this.view = CreateElement("div",{
			classes:["winLinesAnimation-Container"],
			style:{
				height : "100%",
				width : "100%",
				position : "absolute",
				zIndex : ZIndex.WinLines.toString(),
			}
		})

		this.view.appendChild(this.barsLeftView);
		this.view.appendChild(this.barsRightView);
		this.view.appendChild(this.winLines.View());
		// nothing to load here
	}


	public Start(resultLines: LineWin[], duration:number) {
		// Log.Debug(this.logGroup, "Start");

		// start with -1, because we increment index before showing
		this.currentLineIndex = -1;

		this.lastResultLines = resultLines;
		this.nextLineInterval.ChangeInterval(duration);
		this.nextLineInterval.Start();

		// show first line right away
		this.NextLine();

		let line: LineWin = this.lastResultLines[this.currentLineIndex];
		//this.winLineMarkers.Show(line.LineIndex , this.winLines.GetColor(line.LineIndex));
		this.OnStartLine(line, this.winLines.GetColor(line.LineIndex), this.animateOnlyWinningSymbols);
	}

	public GetDuration(): number
	{
		return this.lastResultLines.length * this.lineDuration;
	}

	private NextLine() {

		// we finished!
		if (this.currentLineIndex +1 >= this.lastResultLines.length) {
			// hide last line, finish animation
			this.nextLineInterval.Stop();

			this.winLines.Hide(this.lastResultLines[this.currentLineIndex].LineIndex);
			this.winLineMarkers.Hide();
			this.OnComplete();
		}
		// next line
		else {

			// hide current line, show next line
			if (this.currentLineIndex >= 0) {
				this.winLines.Hide(this.lastResultLines[this.currentLineIndex].LineIndex);
			}

			this.currentLineIndex++;

			let line: LineWin = this.lastResultLines[this.currentLineIndex];

			// Log.Debug(this.logGroup, "Showing line " + this.currentLineIndex + " of " + this.lastResultLines.length + " => " + line.LineIndex);
			this.winLines.Show(line.LineIndex);
			this.winLineMarkers.Show(line.LineIndex , this.winLines.GetColor(line.LineIndex));

			// notify all of next line
			this.OnNextLine(line, this.winLines.GetColor(line.LineIndex), this.animateOnlyWinningSymbols);
		}
	}

	public Update() {

	}

	public RequestStop() {
		// stop timer, hide shown line, call complete handler
		this.nextLineInterval.Stop();
		
		this.winLines.Hide(this.lastResultLines[this.currentLineIndex].LineIndex);
		this.winLineMarkers.Hide();
		this.OnComplete();
	}


	/****************
	 *	CALLBACKS	*
	 ****************/
	//completeCallbacks: WinLinesAnimationCompleteCallback[] = [];
	// protected OnComplete(interrupted: boolean = false): void {
	// 	// Log.Debug(this.logGroup, "Complete");
	// 	for (let i = 0; i < this.completeCallbacks.length; i++) {
	// 		this.completeCallbacks[i](interrupted);
	// 	}
	// }

	public override AddCompleteCallbacks(callback: WinLinesAnimationCompleteCallback): void {
		this.completeCallbacks.push(callback);
	}

	//nextLineCallbacks: WinLinesAnimationNewLineCallback[] = [];
	// protected OnNextLine(line: SlotSpinResultLine, color: Color): void {
	// 	for (let i = 0; i < this.nextLineCallbacks.length; i++) {
	// 		this.nextLineCallbacks[i](line, color);
	// 	}
	// }

	public override AddNextLineCallback(callback: WinLinesAnimationNewLineCallback): void {
		this.nextLineCallbacks.push(callback);
	}

	public View(): HTMLElement
	{
		// does not have HTML element, but svg element, whatever :)
		return this.view;
	}
}
